<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" :disabled="triggerSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="searchDate" :disabled="triggerSearch"
                    :format="getDefaultDateFormat" allowClear />
                </div>

                <div class="m-form-item-wrapper">
                  <label for="director">Director</label>
                  <a-select placeholder="Choose director" v-model="director" :disabled="triggerSearch" class="width-full"
                    initialValue="undefined" allowClear>
                    <a-select-option v-for="item in listDirector" :key="item.value" :value="item.value">{{ item.text
                    }}</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" :disabled="triggerSearch" class="width-full"
                    initialValue="delivered" allowClear>
                    <a-select-option v-for="item in getStatus" :key="item.id" :value="item.value">{{ item.label
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="Director Klaim List" :manifestLink="getManifestLink" :dataList="searching"
        :price="true" :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "klaimDirektur",
  props: ["prnMenu"],
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      listDirector: [],
      searchDate: null,
      search: "",
      status: undefined,
      director: undefined,
      triggerSearch: false,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getStandartFormatDate);
        outputData = _.filter(outputData, { tgl_buat: filter });
      }

      if (this.director) {
        outputData = outputData.filter(
          (obj) =>
            obj.tlc_bod &&
            obj.tlc_bod.toLowerCase().indexOf(self.director.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return outputData;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/keuangan") {
        return "SpclKlaimDirekturManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclKlaimDirekturManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "klaim-direktur-pimpro-manifest";
      } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
        return "SpclKlaimDirekturManifestVer";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclKlaimDirekturManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclKlaimDirekturManifestFC";
      } else {
        return "KlaimDirekturManifest";
      }
      
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/klaim_direktur",
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem("nvky"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.listDirector = response.data.director;
          _.forEach(response.data.data, (data) => {
            this.dataList.push({
              title: data.no_klaim_direktur,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: {
                pembuat: data.tlc,
                tanggal: moment(data.tgl_buat).format(
                  this.getDefaultDateFormat
                ),
                price: this.formatCurrency(data.currency, data.grand_total),
              },
              status: data.status,
              id: data.id_klaim_direktur,
              price: data.grand_total,
              cancelStatus: data.cancel_sts,
              tgl_buat: data.tgl_buat,
              searchQ:
                data.no_klaim_direktur + " " + data.tlc_pic + " " + data.tlc,
              tlc_bod: data.tlc_bod,
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    clickTabed(val) {
      this.search = "";
      this.searchDate = undefined;
      this.director = undefined;
      this.status = undefined;
      if (val == "draft") {
        this.triggerSearch = true;
      } else {
        this.triggerSearch = false;
      }
    },
  },
};
</script>

<style></style>
